exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.role-switch-trigger[data-v-e46fc40c] {\n  cursor: pointer;\n  text-decoration: underline;\n}\r\n", ""]);

// exports
